<template>
  <h3 class="text-center mb-2">{{ data.content }}</h3>
</template>

<script>
export default {
  name: "BlockTitle",
  props: {
    data: {
      type: Object,
      required: true,
      content: {
        type: String,
        default: ""
      }
    }
  }
};
</script>
